import { NgModule } from '@angular/core'
import { BrowserModule } from '@angular/platform-browser'
import { FormsModule, ReactiveFormsModule } from '@angular/forms'
import { LayoutPromotionComponent } from './layout-promotion/layout-promotion.component'
import { PromotionRoutingModule } from './promotion.routing'

import { PromotionComponent, SafeHtmlPipe } from './promotion.component'
import { PlanComponent } from './plan/plan.component'
import { HeaderComponent } from './layout-promotion/header.component'
import { FooterComponent } from './layout-promotion/footer.component'
import { CampaignComponent } from './campaign/campaign.component'
import { TutorialComponent } from './tutorial/tutorial.component'
import { ApplicationComponent } from './application/application.component'
import { FaqComponent } from './faq/faq.component'
import { ContactComponent } from './contact/contact.component'
import { CompanyComponent } from './company/company.component'
import { ForgotPasswordComponent } from './forgot-password/forgot-password.component'
import { ResetPasswordComponent } from './reset-password/reset-password.component'

@NgModule({
    imports: [
        BrowserModule,
        FormsModule,
        PromotionRoutingModule,
        ReactiveFormsModule,
    ],
    declarations: [
        LayoutPromotionComponent,
        PromotionComponent,
        PlanComponent,
        HeaderComponent,
        FooterComponent,
        SafeHtmlPipe,
        CampaignComponent,
        TutorialComponent,
        ApplicationComponent,
        FaqComponent,
        ContactComponent,
        CompanyComponent,
        ForgotPasswordComponent,
        ResetPasswordComponent,
    ],
})
export class PromotionModule {
}



// WEBPACK FOOTER //
// ./src/app/promotion/promotion.module.ts